module.exports = __webpack_public_path__ + "img/kr-product-card3-step4.70382fd.png";